import { useContext, useEffect, useState } from "react";
import { CondutorInterface as iData } from "../../interfaces";
import condutorService from "../../services/CondutorService";
import { Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { JCaption, JCard, JCardBody, JHeader, JPaginacao, JTable, JTBody, JTHead } from "../../components/Components";
import { AuthContext } from "../../contexts/AuthContext";

export default function IndexCondutor() {
    const [dados, setDados] = useState<iData[]>([]);
    const [showSpinner, setShowSpinner] = useState(true);
    const [search, setSearch] = useState('');
    const [meta, setMeta] = useState<any>(null)
    const [links, setLinks] = useState<any>(null)
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Insert') {
            navigate('/condutor/create');
        }
    }

    const searchFilter = (page: string | null = null) => {
        setShowSpinner(true);

        condutorService.getAllPaginate(search, page).then(response => {
            setDados(response.data);
            setLinks(response.links);
            setMeta(response.meta);
            setShowSpinner(false);

        }).catch(err => {
            if (err.response.status === 403) {
                authContext?.setShowError(true)
                authContext?.setShowMessageError(err.response.data.message);
                navigate('/');
            }
            setShowSpinner(false);
        });
    }

    const handlePageChange = (page: string | null = null) => {
        searchFilter(page)
    }

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown)
        searchFilter();

        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [search]);

    return (
        <>
            <div className="row d-flex justify-content-between align-items-start g-2">
                <Col md>
                    <JCard >
                        <JHeader
                            urlCreate="/condutor/create"
                            search={search}
                            setSearch={setSearch}
                            showSpinner={showSpinner}
                            permissionCreate={authContext?.checkPermission('condutor_create')}
                            permissionSearch={authContext?.checkPermission('condutor_search')}
                        />

                        <JCardBody>
                            <JCaption title="Lista de Condutores">

                                <JPaginacao
                                    links={links ?? {}}
                                    meta={meta ?? {}}
                                    handlePageChange={handlePageChange} />
                            </JCaption>
                            <JTable >
                                <JTHead>
                                    <tr>
                                        <th style={{ width: '7rem' }}>CPF</th>
                                        <th>NOME</th>
                                        <th className="text-center" style={{ width: '5rem' }}>ATIVO?</th>
                                    </tr>
                                </JTHead>
                                <JTBody>
                                    {dados?.map((data) => (
                                        <tr key={data.id}>
                                            <td>
                                                <Link title="Clique no CPF para editar e ou remover"
                                                    className="text-primary"
                                                    to={`/condutor/${data.id}`}
                                                    style={{ textDecoration: 'none' }}>
                                                    {data.cpf}
                                                </Link>
                                            </td>
                                            <td>{data.name}</td>
                                            <td className="text-center">
                                                <FontAwesomeIcon
                                                    className={data.active ? 'text-success' : 'text-danger'}
                                                    icon={data.active ? faCheck : faXmark} />
                                            </td>
                                        </tr>
                                    ))}
                                </JTBody>
                            </JTable>
                        </JCardBody>
                    </JCard>
                </Col>
            </div>
        </>
    );
};

